define(function(require) {
	const Marionette = require('backbone.marionette');
	const tpl = require('./t_lov_logged_in_user.hbs');

	return Marionette.LayoutView.extend({
		template: tpl,
		ui:{
		},
		childEvents:{
		},
		views:{},
		initialize: function(options) {
			this.options = options;
		},
		onShow: function() {
		},
		templateHelpers: function() {
		  return {
			currentUserFullName: this.options.currentUser && this.options.currentUser.identity ? this.options.currentUser.identity.firstName + ' ' + this.options.currentUser.identity.lastName : '',
			currentUserEmail: this.options.currentUser && this.options.currentUser.eMailAddress ? this.options.currentUser.eMailAddress.toLowerCase() : '',
			showOptionalButton: this.options.config.showOptionalButton,
			optionLink: this.options.config.optionalButtonPage,
			optionalButtonLabel: this.options.config.optionalButtonLabel
		  };
		}
	});
});
